import React, { Component } from 'react'
import { Button, Modal } from 'react-bootstrap'
import { connectModal } from 'redux-modal'

import {ANDROID_APP_URL, APPLE_APP_URL, ANDROID} from 'common/constants'
import { deviceType } from 'common/util/features'

class UpdateAppModal extends Component {

  constructor(props) {
    super(props)
  }

  handleUpdate() {
    this.props.handleHide()
    window.location = deviceType() === ANDROID ? ANDROID_APP_URL : APPLE_APP_URL
  }

  render() {
    return (
      <Modal show={this.props.show}>
        <Modal.Header>
          <Modal.Title>New Update Available</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <div className="UpdateModal">
            This feature requires the latest version of the Opcity app.
          </div>
        </Modal.Body>

        <Modal.Footer>
          <Button onClick={this.props.handleHide}>Cancel</Button>
          <Button onClick={() => this.handleUpdate()} bsStyle="primary">Update</Button>
        </Modal.Footer>
      </Modal>)
  }
}
export default connectModal({ name: 'UpdateAppModal', destroyOnHide: true })(UpdateAppModal)